import { O as Overlay } from "./utilities-overlay.js";
import { u as updateColumnCount, j as safeFetch, m as mediaQueries, k as scrollLockViewport, e as escListener } from "./utilities-utils.js";
import "./utilities-nav-utils.js";
const overlay = new Overlay();
class Blog extends HTMLElement {
  constructor() {
    super();
    this.tags = /* @__PURE__ */ new Set();
    this.parser = new DOMParser();
    this.originalPathname = this.getOriginalPathname();
  }
  connectedCallback() {
    this.load();
    this.loadPagination();
    if (document.querySelector(".facets form")) {
      const filterForm = document.querySelector(".facets form");
      const inputElements = filterForm.querySelectorAll('input[type="checkbox"]');
      if (inputElements.length > 0) {
        inputElements.forEach((inputElement) => {
          inputElement.addEventListener("change", (e) => {
            const tag = e.target.value;
            if (e.target.checked) {
              this.tags.add(tag);
            } else {
              this.tags.delete(tag);
            }
            const newUrl = this.getUrl(Array.from(this.tags));
            window.history.pushState({}, "", newUrl);
            this.updateContent(newUrl);
            this.scrollIntoView();
          });
          this.tags.length && this.tags.find((tag) => tag === inputElement.value) !== void 0 && inputElement.setAttribute("checked", true);
        });
      }
    }
    this.toggleSidebar();
    updateColumnCount();
  }
  getOriginalPathname = () => {
    const [originalPathname] = window.location.pathname.split("/tagged/");
    return originalPathname.endsWith("/") ? originalPathname : `${originalPathname}/`;
  };
  getInitialTags = () => {
    const hasTags = window.location.pathname.includes("/tagged/");
    if (hasTags) {
      const [, initialJoined] = window.location.pathname.split("/tagged/");
      return initialJoined.split("+");
    }
    return [];
  };
  scrollIntoView = () => {
    const content = document.querySelector("#blog-content");
    if (content) content.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  load = () => {
    const initialTags = this.getInitialTags();
    const inputElements = document.querySelectorAll('input[name="tag"]');
    initialTags.forEach((tag) => {
      this.tags.add(tag);
    });
    if (inputElements.length > 0) {
      inputElements.forEach((inputElement) => {
        if (this.tags.has(inputElement.value)) {
          inputElement.setAttribute("checked", true);
        }
      });
    }
  };
  loadPagination = () => {
    const pagination = document.querySelector(".pagination");
    if (pagination) {
      pagination.addEventListener("click", (e) => {
        if (e.target.tagName === "A") {
          e.preventDefault();
          const newUrl = e.target.href;
          window.history.pushState({}, "", newUrl);
          this.updateContent(newUrl);
          setTimeout(this.scrollIntoView, 1e3);
        }
      });
    }
  };
  getUrl = (tags = []) => {
    if (tags.length > 0) {
      return `${this.originalPathname}tagged/${tags.join("+")}?page=1`;
    }
    return this.originalPathname;
  };
  updateContent = async (newUrl) => {
    const blogSectionId = document.querySelector("#main-blog").dataset.sectionId;
    const heroElement = document.querySelector("#hero-basic");
    const heroSectionId = heroElement ? heroElement.dataset.sectionId : null;
    const blogUrl = newUrl.includes("?") ? `${newUrl}&section_id=${blogSectionId}` : `${newUrl}?section_id=${blogSectionId}`;
    const heroUrl = heroSectionId ? newUrl.includes("?") ? `${newUrl}&section_id=${heroSectionId}` : `${newUrl}?section_id=${heroSectionId}` : null;
    const blogResponse = await safeFetch(blogUrl);
    const heroResponse = heroUrl ? await safeFetch(heroUrl) : null;
    if (blogResponse.error) {
      console.error(blogResponse.error);
    }
    const parsedBlog = this.parser.parseFromString(await blogResponse.response.text(), "text/html");
    const container = parsedBlog.querySelector(".grid-archive__content");
    const hasError = container.innerHTML.includes("Liquid error");
    if (hasError) {
      container.style.gridTemplateColumns = "1fr";
      container.innerHTML = '<p class="nothing_found"><strong>' + searchStrings.nothing_found + "</strong>" + searchStrings.try_different_filters + "</p>";
    }
    document.querySelector("#blog-content").innerHTML = parsedBlog.querySelector("#blog-content").innerHTML;
    if (heroResponse) {
      if (heroResponse.error) {
        console.error(heroResponse.error);
      } else {
        const parsedHero = this.parser.parseFromString(
          await heroResponse.response.text(),
          "text/html"
        );
        parsedHero.querySelectorAll(".icon").forEach((icon) => {
          icon.classList.add("loaded");
        });
        document.querySelector(".hero-basic .container").innerHTML = parsedHero.querySelector(".hero-basic .container").innerHTML;
      }
    }
    this.loadPagination();
    updateColumnCount();
  };
  // manage sidebar visibility logic (laptop down/desktop)
  toggleSidebar = () => {
    document.querySelectorAll(".grid-archive").forEach((archiveGrid) => {
      const toggleFiltersButton = archiveGrid.closest(".shopify-section").querySelector(".toggle-filtering");
      const filtersContainer = archiveGrid.querySelector(".grid-archive__filters-container");
      const isMobileFiltersOpen = () => archiveGrid.classList.contains("grid-archive__main-container-mobile--filters-shown");
      const closeFilters = () => {
        archiveGrid.classList.remove("grid-archive__main-container--filters-shown");
        escListener(false, closeFilters);
      };
      const openFilters = () => {
        archiveGrid.classList.add("grid-archive__main-container--filters-shown");
        escListener(true, closeFilters);
      };
      const toggleFilters = () => {
        const isFiltersOpen = archiveGrid.classList.contains(
          "grid-archive__main-container--filters-shown"
        );
        if (isFiltersOpen) {
          closeFilters();
        } else {
          openFilters();
        }
      };
      const closeFiltersMobile = () => {
        archiveGrid.classList.remove("grid-archive__main-container-mobile--filters-shown");
        scrollLockViewport(false, "laptop-down");
        overlay.close();
        escListener(false, closeFiltersMobile);
      };
      const outsidePopupClickListener = () => {
        filtersContainer.addEventListener("click", outsidePopupClick);
      };
      const outsidePopupClick = (e) => {
        if (!e.target.closest(".facets")) {
          closeFiltersMobile();
          filtersContainer.removeEventListener("click", outsidePopupClick);
        }
      };
      const openFiltersMobile = () => {
        archiveGrid.classList.add("grid-archive__main-container-mobile--filters-shown");
        scrollLockViewport(true, "laptop-down");
        overlay.open({
          attachElements: [filtersContainer]
        });
        escListener(true, closeFiltersMobile);
        outsidePopupClickListener();
      };
      if (toggleFiltersButton) {
        toggleFiltersButton.addEventListener("click", () => {
          if (mediaQueries.isLargeDown.matches) {
            openFiltersMobile();
          } else {
            toggleFilters();
          }
        });
      }
      if (filtersContainer) {
        filtersContainer.querySelector(".facets__mobile-close").addEventListener("click", (e) => {
          e.preventDefault();
          closeFiltersMobile();
        });
      }
      const resetOnResize = () => {
        mediaQueries.isLargeDown.addEventListener("change", () => {
          if (mediaQueries.isLargeDown.matches) {
            if (isMobileFiltersOpen()) {
              closeFiltersMobile();
            }
          }
        });
      };
      resetOnResize();
    });
  };
}
if (!customElements.get("blog-component")) {
  customElements.define("blog-component", Blog);
}
